import React from 'react';
import { Modal, Header, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { submit, isValid, isDirty } from 'redux-form';

import { ASSIGN_TAX_SITES_FORM_NAME } from 'Common/FormEnum';
import { AssignTaxRateSitesFieldEnum as Fields } from 'Common/FieldEnum';

import { AssignSitesForm } from './AssignSitesForm';
import * as actions from '../../state/taxRates/actions';
import * as selectors from '../../state/taxRates/selectors';

function AssignSitesModalContainer(props) {
  const {
    isOpen,
    onClose,
    onSubmit,
    submit,
    isDirty,
    rowData,
    loading,
    handleAssignSitesBackClick,
  } = props;

  const sites = rowData ? rowData.Sites : [];
  const name = rowData ? rowData.Name : '';

  return (
    <Modal
      open={isOpen}
      onClose={() => onClose(isDirty)}
      size="large"
      closeIcon
    >
      <Header content={`Assign Tax Rate to Sites: ${name}`} icon="signup" />
      <Modal.Content className="p-t-0">
        <Modal.Description>
          <AssignSitesForm
            onSubmit={onSubmit}
            initialValues={{ [Fields.Sites]: sites }}
            taxRateSites={sites}
            loading={loading}
          />
        </Modal.Description>
      </Modal.Content>

      <Modal.Actions>
        <Button
          color="orange"
          size="big"
          content="Save"
          onClick={() => submit(ASSIGN_TAX_SITES_FORM_NAME)}
          disabled={loading}
          loading={loading}
        />
        <Button
          color="orange"
          size="big"
          content="Back"
          onClick={() => handleAssignSitesBackClick(isDirty)}
          disabled={loading}
          loading={loading}
          className="pull-left"
        />
      </Modal.Actions>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return {
    isValid: isValid(ASSIGN_TAX_SITES_FORM_NAME)(state),
    isDirty: isDirty(ASSIGN_TAX_SITES_FORM_NAME)(state),
    taxRateSites: selectors.getTaxRateSites(state),
    loading: selectors.getTaxRateLoading(state),
  };
};

const mapDispatchToProps = { submit, ...actions };

export const AssignSitesModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignSitesModalContainer);



// WEBPACK FOOTER //
// ./src/pages/controlinformation/components/taxRates/AssignSitesModal.js